import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
} from '@heroui/react';
import { SetURLSearchParams } from 'react-router-dom';
import { Icon } from '@iconify/react';
import { LocationsList } from '@ui/location/locations-list';

export const ProductSortModal = ({
  isOpen,
  onOpenChange,
  onClose,
  searchParams,
  setSearchParams,
}: {
  isOpen?: boolean;
  onOpenChange?: (isOpen: boolean) => void;
  onClose?: () => void;
  searchParams: URLSearchParams;
  setSearchParams: SetURLSearchParams;
}) => {
  return (
    <Modal
      classNames={{ base: 'rounded-b-none' }}
      onOpenChange={onOpenChange}
      hideCloseButton
      isOpen={isOpen}
    >
      <ModalContent>
        <ModalHeader className="border-b text-[#222223] font-semibold text-base justify-between py-1 pr-2 flex flex-row items-center">
          Сортировка
          <Button isIconOnly variant="light" onPress={onClose}>
            <Icon
              width={24}
              height={24}
              icon="famicons:close"
              color="#9CA5AC"
            />
          </Button>
        </ModalHeader>
        <ModalBody className="px-4">
          <div>
            <LocationsList
              value={searchParams.get('sort_by') || 'lower'}
              onSelect={(key) => {
                searchParams.set('sort_by', key);
                setSearchParams(searchParams);
                onClose?.();
              }}
              isDivided
              items={[
                { name: 'Сначала дешевле', value: 'lower' },
                { name: 'Сначала дороже', value: 'higher' },
                { name: 'По популярности', value: 'popular' },
                { name: 'Сначала новинки', value: 'new' },
              ]}
            />
          </div>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
